<template>
  <div class="toolsBox">
    <div class="qrCode">
      <div class="toolsItem">
        <img style="margin-top: 10px; width: 25px ;height:25px" alt="问卷" src="@/assets/img/wenjuanicon.png"/>
      </div>
      <div class="qrCodeBox">
        <img src="@/assets/img/qrCode.png" alt="二维码" style="display: block; width: 105px ;height:105px"/>
        <div style="font-size: 12px; text-align: center">扫描二维码</div>
        <div style="font-size: 12px; text-align: center">反馈问题、收集建议</div>
      </div>
    </div>
    <div class="toolsItem" @click="toPage('help')">
      <el-tooltip class="item" effect="dark" content="帮助手册介绍了系统功能使用，以及一些常见问题" placement="left">
        <img style="margin-top: 10px; width: 25px ;height:25px" alt="咨询" src="@/assets/img/zixunicon.png"/>
      </el-tooltip>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    toPage (index) {
      if (index === 'help') {
        const helpHtml = this.$router.resolve({
          path: '/help/'
        })
        window.open(helpHtml.href, '_blank')
      }
    }
  }
}
</script>
<style scoped>
  .toolsBox {
    position: fixed;
    right: 5px;
    bottom: 20vh;
    width: 45px;
    z-index: 100
  }
  .toolsItem {
    background-color:#fff;;
    opacity: 0.9;
    text-align: center;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    margin-top: 10px;
  }
  .qrCodeBox {
    display: none;
    position: absolute;
    top: 15px;
    left: -140px;
    padding: 5px;
    border: 3px solid #4b979f;
    background-color: #fff;
  }
  .qrCode:hover .qrCodeBox {
    display: block;
  }
</style>
